export const PAYMENT_STEPS = {
  FIRST: 0,
  SECOND: 1,
  THIRD: 2,
};

export const CREDIT_CARD_BRANDS_LIST = [
  "amex",
  "discover",
  "mastercard",
  "visa",
];

export const CREDIT_CARD_BRANDS = {
  AMERICAN_EXPRESS: "amex",
  DISCOVER: "discover",
  MASTERCARD: "mastercard",
  VISA: "visa",
};

export const SQUARE_CARD_BRANDS = {
  AMERICAN_EXPRESS: "american_express",
  AMERICAN_EXPRESS_FULL: "american express",
  DISCOVER: "discover",
  DISCOVER_DINERS: "discover_diners",
  UNION_PAY: "china_unionpay",
  JCB: "jcb",
  MASTERCARD: "mastercard",
  VISA: "visa",
};

export const NUMBER_PER_PAGE = 10;

export const PRICE_MONTHLY = "$1500";
export const PRICE_YEARLY = "$15,000";

export const PLAN_TYPES = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
};

export const INPUT_MAX_LENGHT = 255;

// eslint-disable-next-line
export const REGEX_ZIP = /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/;

export const MAX_CARD_NAME_LENGTH = 100;

export const ALLOWED_PAYMENT_COUNTRES = ["Canada", "United States"];
export const MAX_ZIP_CODE_LENGTH = 12;

// default setting id, setting is pull based on organization that made the request
export const PAYMENT_SETTING_ID = 1;

export const SUBSCRIPTION = "Subscription";
export const INVOICES = "Invoices";

export const TABS = {
  SUBSCRIPTION: SUBSCRIPTION,
  INVOICES: INVOICES,
};

export const INVOICE_PAID = "paid";
export const INVOICE_CANCELED = "canceled";

export const ACCOUNT_PENDING = "pending";
export const ACCOUNT_RESTRICTED = "restricted";
export const ACCOUNT_RESTRICTED_SOON = "restricted_soon";
export const ACCOUNT_REVIEW = "in_review";
export const ACCOUNT_ENABLED = "enabled";
export const ACCOUNT_REJECTED = "rejected";

export const ACCOUNT_SESSION_TYPE_MNG = "management";
export const ACCOUNT_SESSION_TYPE_OB = "onboarding";
export const ACCOUNT_SESSION_TYPE_PAYOUTS = "payouts";

export const PAYMENT_DEVICE_TABLE_ITEM_ACTIONS = {
  DELETE: "delete-device",
  EDIT_TIP_CONFIG: "edit-tip-config",
};

export const HARDWARE_MODE = {
  READER: "reader",
  LOCATION: "location",
  SETTINGS: "setings",
};

export const STRIPE_PAYMENT_METHODS = {
  CARD: "card",
  APPLE_PAY: "apple_pay",
};

export const STRIPE_EXPRESS_CHECKOUT_PAYMENT_METHODS = {
  applePay: "always",
  googlePay: "never",
  link: "never",
  paypal: "never",
  amazonPay: "never",
  klarna: "never",
};

export const CURRENCY = "usd";

export const DOWN_PAYMENT_INTENT_PURPOSE = "down_payment";

export const PAYMENT_LINK_INTENT_PURPOSE = "payment_link";

export const EMPTY_SUMMARY = {
  subtotal: "0.00",
  discountAmount: "0.00",
  taxAmount: "0.00",
  apptFeeDeduction: "0.00",
  totalDue: "0.00",
};

export const paymentColor = {
  red: "#ff4d4f",
  orange: "#f7924f",
  green: "#42b35e",
  grey: "#727d8d",
};

export const invoiceStatusColors = {
  open: paymentColor.orange,
  paid: paymentColor.green,
  Paid: paymentColor.green,
  Unpaid: paymentColor.orange,
  Completed: paymentColor.green,
  Approved: paymentColor.orange,
  Refunded: paymentColor.orange,
  "Partially Refunded": paymentColor.orange,
};

export const PAYMENT_LINK_STATUSES = {
  ACTIVE: "active",
  EXPIRED: "expired",
  VOID: "void",
  CANCELED: "canceled",
  PAID: "paid",
};

export const paymentLinkStatusColors = {
  active: paymentColor.green,
  expired: paymentColor.orange,
  void: paymentColor.grey,
  canceled: paymentColor.grey,
  paid: paymentColor.green,
};

export const refundStatusColors = {
  pending: paymentColor.orange,
  completed: paymentColor.green,
  failed: paymentColor.red,
};

export const REFUND_ARN_STATUS = {
  AVAILABLE: "available",
  PENDING: "pending",
};
